"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractView = void 0;
var CustomEventTarget_1 = require("../../helpers/CustomEventTarget");
var EVENT_LISTENER_ADD = 'addEventListener';
var EVENT_LISTENER_REMOVE = 'removeEventListener';
var AbstractView = /** @class */ (function (_super) {
    __extends(AbstractView, _super);
    function AbstractView(el) {
        var _this = _super.call(this) || this;
        _this.events = [];
        _this.el = el;
        setTimeout(function () { return _this.attachEvents(); });
        return _this;
    }
    AbstractView.prototype.attachEvents = function () {
        this.detachEvents();
        this.loopThroughEvents(EVENT_LISTENER_ADD);
    };
    AbstractView.prototype.detachEvents = function () {
        this.loopThroughEvents(EVENT_LISTENER_REMOVE);
    };
    AbstractView.prototype.loopThroughEvents = function (state) {
        for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
            var event_1 = _a[_i];
            this.loopThroughQueries(event_1, state);
        }
    };
    AbstractView.prototype.loopThroughQueries = function (event, state) {
        for (var _i = 0, _a = event.queries; _i < _a.length; _i++) {
            var query = _a[_i];
            var querySliced = query.slice(1);
            if (this.el.id === querySliced || this.el.classList.contains(querySliced)) {
                this.toggleEventOnViewItself(event, state);
            }
            else {
                var elements = this.el.querySelectorAll(query);
                this.toggleEventOnElements(event, state, elements);
            }
        }
    };
    AbstractView.prototype.toggleEventOnViewItself = function (event, state) {
        if (state === EVENT_LISTENER_ADD) {
            this.el.addEventListener(event.name, event.callback);
        }
        else if (state === EVENT_LISTENER_REMOVE) {
            this.el.removeEventListener(event.name, event.callback);
        }
    };
    AbstractView.prototype.toggleEventOnElements = function (event, state, elements) {
        for (var i = 0; i < elements.length; i++) {
            if (state === EVENT_LISTENER_ADD) {
                elements[i].addEventListener(event.name, event.callback);
            }
            else if (state === EVENT_LISTENER_REMOVE) {
                elements[i].removeEventListener(event.name, event.callback);
            }
        }
    };
    return AbstractView;
}(CustomEventTarget_1.CustomEventTarget));
exports.AbstractView = AbstractView;
